export default __webpack_public_path__ + "static/media/blocks3.542effcf.png";